module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-plataform-technican/master-plataform-technican.component.scss
// module id = ./src/app/master/master-plataform-technican/master-plataform-technican.component.scss
// module chunks = main